import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Lista completa de categorías
const navItems = [
  { id: 'home', label: 'Novedades', path: '/' },
  { id: 'menusKebab', label: 'Kebab', path: '/menusKebab' },
  { id: 'menusPatatas', label: 'Tarrina', path: '/menusPatatas' },
  { id: 'paninis', label: 'Paninis', path: '/paninis' },
  { id: 'pizzas', label: 'Tacos', path: '/tacos' },
  { id: 'tacos', label: 'Pizzas', path: '/pizzas' },
  // { id: 'bocadillos', label: 'Bocadillos', path: '/bocadillos' },
  { id: 'platosCombinados', label: 'Platos Combinados', path: '/platosCombinados' },
  { id: 'hamburguesas', label: 'Hamburguesas', path: '/hamburguesas' },
  /*   { id: 'bebidas', label: 'Bebidas', path: '/bebidas' }, */
  { id: 'encargos', label: 'Encargos', path: '/encargos' },
];

function Nav() {
  const [activeButton, setActiveButton] = useState('home');

  const handleButtonClick = (id) => {
    setActiveButton(id);
  };

  return (
    <section className="container mx-auto mt-8 px-6">
      <nav className="menu-nav flex flex-wrap gap-4 justify-center">
        {navItems.map(({ id, label, path }) => (
          <Link
            key={id}
            to={path}
            className={`px-4 py-2 rounded-md text-sm font-semibold transition-colors
              ${activeButton === id
                ? 'bg-red-500 text-white'
                : 'bg-gray-200 text-gray-800 hover:bg-red-100'}
            `}
            onClick={() => handleButtonClick(id)}
          >
            {label}
          </Link>
        ))}
      </nav>
    </section>
  );
}

export default Nav;
